import { create } from "zustand";
import { persist } from "zustand/middleware";

interface AuthState {
  accessToken: string | null;
  accessTokenExpiresAt: string | null;
  refreshToken: string | null;
  user: { id: string; username: string; displayName: string | null } | null;
  setSession: (s: {
    accessToken: string;
    accessTokenExpiresAt: string;
    refreshToken: string;
    user: { id: string; username: string; displayName: string | null };
  }) => void;
  clear: () => void;
  isAuthenticated: () => boolean;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set, get) => ({
      accessToken: null,
      accessTokenExpiresAt: null,
      refreshToken: null,
      user: null,
      setSession: (s) => set(s),
      clear: () =>
        set({
          accessToken: null,
          accessTokenExpiresAt: null,
          refreshToken: null,
          user: null,
        }),
      isAuthenticated: () => !!get().accessToken,
    }),
    { name: "athena.auth" },
  ),
);
